import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { pathwaySteps, storyQuestions } from "../../data/content";
export function StorySection() {
  return <section className="bg-white px-5 py-16 sm:py-24" aria-labelledby="story-title" data-id="element-295" data-mp="buklt0qh8cqg">
      <div className="mx-auto max-w-5xl" data-id="element-296" data-mp="gugieewuh1vz">
        <div id="story-title" data-id="element-297" data-mp="gvi217rxewpb">
          <SectionHeading title="From Studying Otoplasty in Pieces… to Reviewing It With a Structured System" data-id="element-298" data-mp="kviisz2hzjzj" />
        </div>

        <div className="mx-auto mt-10 max-w-2xl space-y-5 text-lg leading-relaxed text-ink/80" data-id="element-299" data-mp="pu3mx9kvent9">
          <p data-id="element-300" data-mp="ukscukgwjcqa">I created Otoplasty Clinical Pathway System™ because I noticed something that deserves more attention in surgical education.</p>
          <p data-id="element-301" data-mp="zjvdzttrgysz">You can read textbooks. Watch operative videos. Attend conferences. Study different approaches to otoplasty.</p>
          <p className="font-semibold text-ink" data-id="element-302" data-mp="14honavqd28xh">And still find yourself looking at a case and asking:</p>
          <ul className="space-y-3" data-id="element-303" data-mp="1vq5ky3a2cbo1">
            {storyQuestions.map(q => <li key={q} className="border-l-4 border-brand bg-brand-soft/60 rounded-r-xl px-4 py-3 font-serif text-xl italic text-navy" data-id="element-304" data-mp="1vo2k0o7dgy4j">
                “{q}”
              </li>)}
          </ul>
          <p className="font-semibold text-ink" data-id="element-305" data-mp="1ltst7ay2w7vx">That is exactly why I created this system.</p>
          <div className="space-y-1 text-ink/70" data-id="element-306" data-mp="1guzg3jmpeiwa">
            <p data-id="element-307" data-mp="2egwt51ibdw0u">Not to replace surgical training.</p>
            <p data-id="element-308" data-mp="2eihlckh5p2vj">Not to replace mentorship.</p>
            <p data-id="element-309" data-mp="29had6kb3q1oc">Not to provide a universal operative protocol.</p>
          </div>
          <p data-id="element-310" data-mp="24qk52zbajkpy">
            But to give you a <strong className="text-ink" data-id="element-311" data-mp="24pivkz9xb6ac">structured educational framework</strong> for reviewing otoplasty, organizing
            procedural knowledge, and making better use of the information you already study.
          </p>
          <p data-id="element-312" data-mp="2x8fuz50lr41a">Something visual. Something practical. Something you can return to repeatedly.</p>
          <p className="font-serif text-2xl font-bold text-navy leading-snug" data-id="element-313" data-mp="2sf3i1s5aclod">
            One procedure. One structured pathway. One organized educational review in approximately 15 minutes.
          </p>
        </div>

        <div className="mt-14 rounded-3xl bg-ink px-5 py-10 sm:px-10 sm:py-14" data-id="element-314" data-mp="vjs0bnbvf2er">
          <h3 className="text-center font-serif text-[28px] sm:text-4xl font-bold text-white" data-id="element-315" data-mp="gssxyu1mpa3m">The Otoplasty Clinical Pathway</h3>
          <ol className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-316" data-mp="7se9xmxa5gwf">
            {pathwaySteps.map((step, i) => <li key={step.title} className="flex gap-4 rounded-2xl bg-white/[0.07] p-5 ring-1 ring-white/10" data-id="element-317" data-mp="buhowlj5r3mg" data-mpi={i}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gold font-serif text-xl font-bold text-ink" data-id="element-318" data-mp="3u0mknj2miapp">
                  {i + 1}
                </span>
                <div data-id="element-319" data-mp="1s7y98mftsgyu">
                  <p className="text-lg font-extrabold uppercase tracking-wider text-white" data-id="element-320" data-mp="1s8rc3cbnymbp">{step.title}</p>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/75" data-id="element-321" data-mp="1x6jdcwy77ksk">{step.text}</p>
                </div>
              </li>)}
          </ol>
          <div className="mx-auto mt-8 max-w-2xl space-y-2 text-center text-white/80" data-id="element-322" data-mp="3cr1uh2pc48cc">
            <p data-id="element-323" data-mp="3rfol40kewmiv">The goal isn't to replace your clinical judgment.</p>
            <p className="font-semibold text-white" data-id="element-324" data-mp="3rgzo3y619q8x">
              The goal is to help you organize your professional learning through a repeatable educational framework.
            </p>
          </div>
        </div>

        <div className="mt-12" data-id="element-325" data-mp="3vh0cobmujhtp">
          <CtaButton label="I want this 6-step educational framework" data-id="element-326" data-mp="3vfqc9fsitxjw" />
        </div>
      </div>
    </section>;
}